'use client'

import { useState } from 'react'

interface Props {
  content: string
  buttonTextShow: string
  buttonTextHide: string
}

export default function ExpandableDescription({ content, buttonTextShow, buttonTextHide }: Props) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="flex flex-col gap-4">
      <div className="relative">
        <div className={`transition-all duration-500 overflow-hidden ${isExpanded ? 'max-h-none' : 'max-h-[20em]'}`}>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
        {!isExpanded && (
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-beige to-transparent" />
        )}
      </div>

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-fit text-green font-bold underline decoration-2 underline-offset-4 hover:opacity-70 transition-opacity"
      >
        {isExpanded ? buttonTextHide : buttonTextShow}
      </button>
    </div>
  )
}